import _ from 'lodash'

export const userAccountLocked = (user) => {
  const account = userAccount(user)
  if (account && account.status !== 'active') {
    return true
  }
  return false
}

export const userIsAuthenticated = (user) => {
  return !_.isNil(user) && !!user.email
}

export const atServiceLimit = (user) => {
  const account = userAccount(user) || {}
  const {stats = {}, limits = {}} = account
  const {serviceCount = 0} = stats
  const {maxServiceCount = 1} = limits
  return serviceCount >= maxServiceCount
}

export const atUserLimit = (user) => {
  const account = userAccount(user) || {}
  const {stats = {}, limits = {}} = account
  const {userCount = 1} = stats
  const {maxUserCount = 1} = limits
  return userCount >= maxUserCount
}

export const userIsSuperUser = (user = {}) => {
  return user.isSuperUser === true
}

export const userIsAdminForAccount = (user = {}, account = {}) => {
  if (userIsSuperUser(user)) {
    return true
  }
  const {admins = []} = account
  return admins.some(a => a === user.id)
}

export const userIsAdmin = (user = {}) => {
  if (userIsSuperUser(user)) {
    return true
  }
  const account = userAccount(user)
  if (account) {
    return userIsAdminForAccount(user, account)
  }
  return false
}

export const userIsBillingOwnerForAccount = (user = {}, account = {}) => {
  return account.billingOwner === user.id
}

export const userIsBillingOwner = (user = {}) => {
  if (userIsSuperUser(user)) {
    return true
  }
  const account = userAccount(user)
  if (!account) {
    return false
  }
  return userIsBillingOwnerForAccount(user, account)
}

export const userAccount = (user = {}, asId = false) => {
  let {activeAccount} = user
  if (userIsSuperUser(user) && !!user.superUserAccount) {
    activeAccount = user.superUserAccount
  }
  if (activeAccount) {
    if (asId) {
      return _.isObject(activeAccount) ? activeAccount.id : activeAccount
    }
    return activeAccount
  }
}

export const accountId = (account) => {
  return _.isObject(account) ? account.id : account
}

export const userName = (user) => {
  if (!user) {
    return 'n/a'
  }
  return user.first && user.last ? `${user.first} ${user.last}` : user.email
}

export const userEmail = (user) => {
  if (!user) {
    return 'n/a'
  }
  return user.email
}

export const isAuthRoute = (pathname) => {
  return pathname.indexOf('/auth') > -1
}
